$(function () {
  // Custom Audio Player
  function initCustomAudioPlayer() {
    $('.custom-audio-player').each(function () {
      var $player = $(this);
      var $audio = $player.find('audio');
      var audio = $audio[0];
      var $playPauseBtn = $player.find('.audio-play-pause');
      var $progressCircle = $player.find('.audio-progress');
      var $currentTime = $player.find('.audio-current-time');

      // Circle circumference: 2 * π * r = 2 * π * 81 ≈ 508.938
      var circumference = 2 * Math.PI * 81;

      // Format time
      function formatTime(seconds) {
        if (isNaN(seconds)) return '0:00';
        var mins = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return mins + ':' + (secs < 10 ? '0' : '') + secs;
      }

      // Update progress circle
      function updateProgress() {
        if (audio.duration) {
          var percent = audio.currentTime / audio.duration;
          var offset = circumference * (1 - percent);
          $progressCircle.css('stroke-dashoffset', offset);
          $currentTime.text(formatTime(audio.currentTime));
        }
      }

      // Update duration when metadata loads
      $audio.on('loadedmetadata', function () {
        // Set initial stroke-dasharray
        $progressCircle.css('stroke-dasharray', circumference);
        updateProgress();
      });

      // Update progress
      $audio.on('timeupdate', function () {
        updateProgress();
      });

      // Play/Pause button
      $playPauseBtn.on('click', function () {
        if (audio.paused) {
          audio.play();
          $playPauseBtn.addClass('playing');
          $playPauseBtn.find('.audio-icon').removeClass('bi-play-fill').addClass('bi-pause-fill');
        } else {
          audio.pause();
          $playPauseBtn.removeClass('playing');
          $playPauseBtn.find('.audio-icon').removeClass('bi-pause-fill').addClass('bi-play-fill');
        }
      });

      // Handle audio end
      $audio.on('ended', function () {
        $playPauseBtn.removeClass('playing');
        $playPauseBtn.find('.audio-icon').removeClass('bi-pause-fill').addClass('bi-play-fill');
        $progressCircle.css('stroke-dashoffset', circumference);
        $currentTime.text('0:00');
      });
    });
  }

  // Initialize custom audio players
  initCustomAudioPlayer();
});
